export function singularAppointment(state = null, action) {
  switch (action.type) {
    case "SINGULAR_APPOINTMENT_SUCCESS": {
      return action.data;
    }
    case "SINGULAR_APPOINTMENT_FAILED": {
      return null;
    }
    case "SINGULAR_APPOINTMENT_RESET": {
      return null;
    }
    default:
      return state;
  }
}
